<div class="versions">
  @for (version of versions; track version) {
    <div
      class="version"
      (click)="version.id !== otherSelectedVersion.id && onSelect.emit(version)"
      [class.selected]="version.id === selectedVersion.id || version.id === otherSelectedVersion.id"
      [class.disabled]="version.id === otherSelectedVersion.id"
    >
      <app-badge [color]="version.id === asset.version_data.id ? 'primary' : 'orange'" [stroke]="true">
        {{ version.version_name || 'v1' | uppercase }}
      </app-badge>
      <img
        [src]="
          version
            | assetVersionUrl
              : version.uuid
              : version['status']
              : version.watermark_uuid
              : 64
              : undefined
              : asset.watermark_enabled
            | async
        "
        alt=""
      />
      <div class="version-info">
        @if (asset.version_data.id === version.id) {
          <div class="primary">PRIMARY</div>
        }
        <b
          >{{ names[version.id].name }}<span>.{{ names[version.id].ext }}</span></b
        >
        <span class="date">{{
          (version.created_at * 1000 | date: 'MMM d, yyyy') + ' at ' + (version.created_at * 1000 | date: 'HH:mm')
        }}</span>
      </div>
      <div class="radio"></div>
    </div>
  }
</div>
